import Vue from 'vue'
import App from './App.vue'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import SelectPage from 'v-selectpage'
import VueHtml2pdf from 'vue-html2pdf'

// Import Bootstrap and BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

Vue.use(SelectPage)

Vue.use(VueHtml2pdf)

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#app')
